import { render, staticRenderFns } from "./_trip.vue?vue&type=template&id=295c06b8&"
import script from "./_trip.vue?vue&type=script&lang=js&"
export * from "./_trip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports